export default {
      id: "modal-success-usage",
      viewBox: "0 0 38 38",
      url: "/" + "images/icons.3.109.2.svg#modal-success-usage",
      toString: function () {
        return this.url;
      }
    }